// This file is auto-generated by @hey-api/openapi-ts

import type { GetExperienceListResponse, GetRelatedArticlesResponse } from './types.gen';

const relatedArticleSchemaResponseTransformer = (data: any) => {
  if (data.published_at) {
    data.published_at = new Date(data.published_at);
  }
  return data;
};

export const getRelatedArticlesResponseTransformer = async (data: any): Promise<GetRelatedArticlesResponse> => {
  if (data.results) {
    data.results = data.results.map((item: any) => relatedArticleSchemaResponseTransformer(item));
  }
  return data;
};

const expGuideSchemaResponseTransformer = (data: any) => {
  if (data.date_joined) {
    data.date_joined = new Date(data.date_joined);
  }
  if (data.is_guide_since) {
    data.is_guide_since = new Date(data.is_guide_since);
  }
  return data;
};

const experienceSchemaResponseTransformer = (data: any) => {
  data.guide = expGuideSchemaResponseTransformer(data.guide);
  return data;
};

export const getExperienceListResponseTransformer = async (data: any): Promise<GetExperienceListResponse> => {
  data.results = data.results.map((item: any) => experienceSchemaResponseTransformer(item));
  return data;
};
